<template>
  <v-container fluid>
      <v-card elevation="0">

      <v-card-title>
     Avertissements
    </v-card-title>
    <v-row no-gutters class="mb-4">
        <v-expansion-panels>
        <v-expansion-panel>
          <v-row no-gutters>
            <v-card-text class="justify-center">
            <div align = justify>
              Avant d'explorer les données de causes médicales de décès en libre accès, veuillez prendre connaissance de leurs métadonnées <a href = "https://www.cepidc.inserm.fr/note-dinformation-0"> disponibles ici</a>. 
              Vous y trouverez notamment la <a href = https://www.cepidc.inserm.fr/documentation/definitions-des-indicateurs-sur-les-causes-de-deces-utilises-sur-le-site-du-cepidc> méthodologie de calcul des indicateurs </a> ainsi que les informations sur les corrections d'erreur et les dates de mises à jour.
              <br>Un <a href = "https://www.cepidc.inserm.fr/documentation/ruptures-de-series-ayant-affecte-les-causes-de-deces-depuis-1979">travail de recensement des ruptures de séries</a> présentes dans la base données sur les causes médicales de décès est en cours, merci d'en prendre note.

              <br><br>La diffusion des données du système national des données de santé en Open Data est régie par l'<a href = "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000038886860/">article L1461-3 du Code de la Santé Publique</a> qui nécessite que l'identification, directe ou indirecte, des personnes concernées y soit impossible.
              Pour ce faire, <b>les jeux de données mis à disposition dans l'application Open Data ont fait l'objet d'une procédure d'anonymisation altérant légèrement l'information. Ces données floutées peuvent ainsi, dans de rares cas, 
              différer très faiblement de la réalité tout en permettant des analyses spatio-temporelles sans biais induit par cette procédure.</b> 
            </div>
            </v-card-text>
          </v-row>

        </v-expansion-panel>

      </v-expansion-panels>
    </v-row>
 
    <v-card-title>
     Métadonnées
    </v-card-title>
      <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
               <!-- &nbsp; permet d'avoir un espace qui est étonnamment supprimé si on met en gras une partie du texte -->
                <v-row no-gutters>
                  <b>Backlog de correction d'erreurs - dernière mise à jour&nbsp;</b> : le 10/07/2025.
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
<div align = justify>
  <b>Anomalie de diffusion</b>
  <p STYLE="padding:0 0 0 20px;"> 
    <b>Date de correction</b> : le 10/07/2025 ; Type d'erreur : mineure 
    <br><u>Description de l'erreur</u> : Le taux brut de mortalité; des &quot;&lt;1 an&quot; était  erroné pour certains dé;partements (avec peu de décès parmi les &lt;1 an). Cette erreur se répercutait sur les taux standardisés des classes d'âge comprenant les enfants de moins de un an.
      Le taux standardisé toutes causes était sous-estimé par exemple de 0,7% pour les hommes tous âges en Guadeloupe en 2021 et de 3,1% pour les moins de 65 ans. 
    <br><u>Mode de correction</u> : Les décès des &lt;1 an ont été réintégrés dans le calcul du taux brut (et donc du taux standardisé).
    <br><u>Communication de l'erreur</u> : cet encart
    <br><b>Date de correction</b> : le 17/06/2025 ; Type d'erreur : mineure 
    <br><u>Description de l'erreur</u> : le taux standardisé de mortalité était erroné pour toutes les années avant 2018 (les effectifs de décès ainsi que les taux bruts n'étaient pas affectés). Les décès des 1-24 ans n'étaient pas comptabilisés dans le calcul du taux. Cette erreur conduisait à un écart, par exemple en 2017, de 0,6% le taux toutes causes et tous âges des hommes, de 0,5% celui des femmes. Cependant, des causes de décès plus spécifiques aux 1-24 ans ont un biais plus important. 
    Par exemple en 2017, pour les causes externes de mortalité, chez les femmes de moins de 65 ans, la sous-estimation atteint 13%. 
    <br><u>Mode de correction</u> : Les décès des 1-24 ans ont été réintégrés dans le calcul du taux standardisé.
    <br><u>Communication de l'erreur</u> : cet encart  + avertissement spécifique à l'institution qui avait partagé ses doutes conduisant au repérage de l'erreur. 
    <br><br><b>Date de correction</b> : le 09/04/2025 ; Type d'erreur : mineure 
    <br><u>Description de l'erreur</u> : le taux brut de mortalité pour la classe des 1-24 ans soit le nombre de décès parmi les 1-24 divisé par la population des 1-24 ans ne prenait pas en compte les décès des enfants âgés de 5-14 ans. Le taux brut de mortalité de cette classe d'âge était donc sous-évalué.
    <br><u>Mode de correction</u> : : Les décès des 5-14 ans ont été réintégrés dans le calcul du taux brut pour les 1-24 ans.
    <br><u>Communication de l'erreur</u> : cet encart
    <br><br><b>Date de correction</b> : le 07/03/2025 ; Type d'erreur : mineure
    <br><u>Description de l'erreur</u>  :  le taux brut de mortalité calculé tous âges (par exemple, taux brut en 2022 selon le sexe) était sous-évalué. Le dénominateur du taux, la population vivante, comprenait trop d'enfants de moins d'un an (qui sont utilisés correctement dans les calculs selon la classe d'âge). La correction augmente le taux brut obtenu d'environ 1%.
    <br><u>Mode de correction</u> : : le bug a été corrigé dans le programme de calcul des taux bruts à compter du 07/03/2025.
    <br><u>Communication de l'erreur</u> : cet encart + avertissement spécifique à l'utilisateur qui avait partagé ses doutes conduisant au repérage de l'erreur.
    <br><br><b>Date de correction</b> : le 03/05/2024 ; Type d'erreur : mineure
    <br><u>Description de l'erreur</u>  : il s'agit d'une anomalie dans la diffusion. Le calcul sur l'outil open-data des taux de décès bruts des moins de 1 an qui se fait à la volée des requêtes pouvait être erroné lorsqu'il s'appliquait à une cause très rare pour cette catégorie (dans ce cas le nombre de décès et la population pris en compte faisait intervenir ceux d'une autre classe d'âge). L'ampleur de l'erreur dépendait de l'écart en mortalité par cause entre catégorie d'âge. Ceci pouvait conduire à des erreurs aussi sur les taux standardisés, mais de moindre ampleur.
    <br><u>Mode de correction</u> : : le bug a été corrigé dans le programme de calcul des taux bruts à compter du 03/05/2024.
    <br><u>Communication de l'erreur</u> : cet encart + avertissement spécifique à l'utilisateur qui avait partagé ses doutes conduisant au repérage de l'erreur.
  </p>
</div>
              </v-expansion-panel-content>
            </v-expansion-panel>
         </v-expansion-panels>
<v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row no-gutters>
                  
                    <b>Journal des modifications de l'outil Open Data (hors correction) - dernière mise à jour&nbsp; </b> : le 24/06/2025.
                 
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
<div align = justify>
<b><u>Mise à jour du 07/07/2025</u></b>
<p STYLE="padding:0 0 0 20px;"> 
<b>Indicateurs</b>
<br>- Mise à disposition de l'indicateur "Taux standardisé de mortalité par âge et sexe", utilisé notamment dans les publications du CépiDc dans le Bulletin Epidémiologique Hebdomadaire et dans Etudes et Résultats.
<br>- Les classes d'âge disponibles pour les deux taux standardisés sont celles utilisées dans les publications : 0-64 ans, 65-84 ans, 85 ans et plus.
</p>
<b><u>Mise à jour du 24/06/2025</u></b>
<p STYLE="padding:0 0 0 20px;"> 
<b>Fichier téléchargeable</b>
<br>- Lorsque l'indicateur utilisé est le taux standardisé de mortalité par âge, le fichier téléchargeable indique en première page la population de référence utilisée.
</p>
<b><u>Mise à jour du 19/06/2025</u></b>
<p STYLE="padding:0 0 0 20px;"> 
<b>Site internet de l'outil</b>
<br>- Information en cartouche "Avertissement" d'un fichier répertoriant les ruptures de séries connues présentes dans la base de données.
</p>
<b><u>Mise à jour du 18/06/2025</u></b>
<p STYLE="padding:0 0 0 20px;"> 
<b>Site internet de l'outil</b>
<br>- Modification de la cartouche "Avertissements" : paragraphe sur la procédure d'anonymisation des données mises à disposition
<br>- Introduction d'une alerte si le taux brut ou standardisé de mortalité est basé sur des populations vivantes provisoires
<br>- Correction des liens externes en erreur 404 
<br>- "Taux standardisé de mortalité" est renommé "Taux standardisé de mortalité par âge" pour exprimer correctement son calcul
<br><b>Fichier téléchargeable</b>
<br>- Passage du format .csv au format .ods (Libre Office)
<br>- La première page du ficher est composée des métadonnées générales, la seconde page du fichier contient les données au format habituel 
</p>
</div>
              </v-expansion-panel-content>
            </v-expansion-panel>
         </v-expansion-panels>
    <v-row no-gutters>
      <v-col>
        <v-expansion-panels>
        <v-expansion-panel>
          <v-row no-gutters>
            <v-card-text class="justify-center">
            <div>
            <b>Mise à disposition des données :</b> <br>
            <p STYLE="padding:0 0 0 20px;"> Dernière mise à jour : Mise à disposition des données pour 2022 le 18 novembre 2024. <br> 
            Prochaine mise à jour : Mise à disposition des données pour 2023 prévue en juillet 2025.</p>
            </div> 
            <div>
            <b>Périmètre des données diffusées:</b> <br>
            <p STYLE="padding:0 0 0 20px;">- Décès ayant eu lieu uniquement en France métropolitaine d'individus domiciliés en France métropolitaine jusqu'en 1999.
            <br> - Décès ayant eu lieu en France métropolitaine, à la Réunion, en Guadeloupe et en Martinique d'individus domiciliés sur ce même champ à partir de l'année 2000.
            <br> - S'y ajoute la Guyane depuis 2001.    
            <br> - Et Mayotte depuis 2014. </p>
            </div>
            <div>
            <b>Données des populations vivantes utilisées</b> (issues de l'Insee et utilisées dans le calcul des taux brut et standardisé de mortalité): <br>
            <p STYLE="padding:0 0 0 20px;"> Dernière mise à jour : 18 novembre 2024.
            <br> Données utilisées : <a href = https://www.insee.fr/fr/metadonnees/source/serie/s1169>Estimations de population de l'Insee</a> par sexe, âge et département.
            <br> Population utilisée comme dénominateur des taux de de mortalité : population de mi-année, moyenne de la population au 1er janvier de l'année étudiée et de l'année suivante.
            <br> Population annuelle encore provisoire : 2021, 2022.</p>
            </div>
               
     
            <v-expansion-panels>

</v-expansion-panels>
            </v-card-text>
          </v-row>

        </v-expansion-panel>

      </v-expansion-panels>

      </v-col>

    </v-row>
  </v-card>
  <ComplexQuery agregration_1_24 />
  </v-container>
</template>

<script>
import ComplexQuery from "@/components/ComplexQuery.vue";

export default {
  name: "Home",
  components: {
    ComplexQuery
   }
};
</script>
